import {
  DOWNLOAD_CONSULTATION_HISTORY,
  DOWNLOAD_CONSULTATION_HISTORY_SUCCESS,
  DOWNLOAD_CONSULTATION_HISTORY_FAILURE,
} from 'store/downloadConsultationHistory/downloadConsultationHistoryAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const downloadConsultationHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_CONSULTATION_HISTORY:
      return { ...state, loading: true };
    case DOWNLOAD_CONSULTATION_HISTORY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DOWNLOAD_CONSULTATION_HISTORY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default downloadConsultationHistoryReducer;
